import _ from "lodash";
/** external */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { WarningTriangleFilled } from "@toddle-edu/ds-icons";
/** internal */
import { useI18n } from "Hooks";
import { CONTENT_UID_TEXT_BOX } from "Worksheet/modules/WorksheetConstants";
/** relative */
import classes from "./QuestionErrorMessage.scss";

const QuestionErrorMessage = props => {
  const { errors, isSubQuestion, questionTypeUid } = props;

  const { t } = useI18n(["worksheet"]);

  const containerClasses = classNames(classes.container, {
    [classes.parentQuestionContainer]: !isSubQuestion,
  });

  const labelClasses = classNames("text-body-3", classes.label);

  return (
    <div className={containerClasses}>
      <WarningTriangleFilled variant="critical" size="xxx-small" />
      {_.isEqual(questionTypeUid, CONTENT_UID_TEXT_BOX) ? (
        <div className={labelClasses}>{t("worksheet:empty_text_box_msg")}</div>
      ) : _.isEmpty(errors) ? null : (
        <div className={labelClasses}>
          {t("worksheet:please_correct_the_following_errors")}
          <ul>
            {errors.map(error => (
              <li key={error}>{t(error)}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

QuestionErrorMessage.propTypes = {
  errors: PropTypes.array,
  isSubQuestion: PropTypes.bool,
};

QuestionErrorMessage.defaultProps = {
  errors: [],
  isSubQuestion: false,
};

export default QuestionErrorMessage;
